import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BaseButton, useT, useIsMobile } from '@repo/common';
import { ReactComponent as BookmarkOutlineIcon } from '@repo/common/assets/icons/24px/icon_24px_bookmark_outline.svg';

const DetailUnavailable = () => {
  const t = useT();
  const isMobile = useIsMobile();
  const LockImageUrl = `${process.env.REACT_APP_ASSETS_URL}/JobBoard/img-jobboard-lock.svg`;
  const navigate = useNavigate();

  return (
    <div className='flex flex-col items-center w-full bg-grayscale-gray01 px-4 tabletV:px-[40px] pt-[140px] tabletV:pt-[140px] pb-[260px] tabletV:pb-[240px]'>
      <div className='max-w-[1166px] flex flex-col items-center text-center'>
        <img
          src={LockImageUrl}
          alt='default banner'
          className='pb-4 tabletH:pb-6 w-[52px] tabletV:w-auto'
        />
        <div className='flex flex-col items-center pb-4 tabletH:pb-6 tabletH:gap-0.5'>
          <div className='typo-b16Strong tabletV:typo-h6 text-text-primary'>
            {t(
              'This job is no longer available',
              '더 이상 확인할 수 없는 공고입니다',
            )}
          </div>
          <div className='typo-b12 tabletV:typo-b16 text-text-primary'>
            {t(
              'This position is no longer open for applications',
              '지원이 마감된 포지션입니다',
            )}
          </div>
        </div>
        <div className='tabletV:pb-[60px]'>
          <BaseButton
            hideIcon
            size={isMobile ? 's' : 'xl'}
            onClick={() => navigate('/jobs')}
          >
            {t('Browse other jobs', '다른 공고 보러 가기')}
          </BaseButton>
        </div>
      </div>

      <div className='fixed inset-x-0 bottom-0 z-[999] flex items-center gap-3 border-t border-grayscale-gray02 bg-grayscale-gray00 px-4 pb-[calc(env(safe-area-inset-bottom)+10px)] pt-3 tabletV:hidden'>
        <span
          aria-hidden='true'
          className='flex size-11 shrink-0 items-center justify-center rounded-full border-[1.6px] border-grayscale-gray02 text-icon-disable'
        >
          <BookmarkOutlineIcon />
        </span>
        <BaseButton size='l' hideIcon width='100%' isDisabled>
          {t('Apply now', '지원하기')}
        </BaseButton>
      </div>
    </div>
  );
};

export default DetailUnavailable;
